import { LightTheme } from 'baseui';
export const gutter = '6px';
export const boxRadius = '2px';
export const colorActive = 'blue';
export const colorHover = '#5d5d5d';
export const usualBorder = '1px solid #aaa';
export const colors: {
  [x: string]: string;
} = {
  grey: '#efefef',
  darkGrey: '#8c8c8c'
};
export const questionInputStyle = {
  width: 'calc(100% - 98px)',
  float: 'right'
};
export const STYLE = {
  primary: LightTheme.colors.primary400,
  warning: LightTheme.colors.warning400,
  positive: LightTheme.colors.positive400,
  negative: LightTheme.colors.negative400
};
export function hexToRgb(hex = '', alpha = '1') {
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? `rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, ${alpha})` : null;
}